const MainTheStarterKit = function() {
    function MainTheStarterKit() {
        this.selector = {
            productdetails: document.querySelectorAll('.product-details-btn'),
            productdetailsmodal: document.getElementById('product-details-modal'),
            productdetailsmodaloverlay: document.getElementById('product-details-modal-overlay'),
            modalclose: document.getElementById('product-details-modal-close'),
            steponevariantselected: document.getElementById('step-one-variant-selected'),
            addtowizard: document.querySelectorAll('.add-to-wizard'),
            addtowizardtwo: document.querySelectorAll('.step-one-container .add-to-wizard'),
            kitclose: document.querySelectorAll('.wizard-container > .variant-selection .kit-close'),
            steponecontainer: document.getElementById("step-one-container"),
            starterkitaddtocart: document.getElementById("starter-kit-add-to-cart"),
            sellingplanoptionsselect: document.getElementById("selling-plan-options-select"),
            stepsbuilderstepone: document.getElementById("steps-builder-step-one"),
            complimentaryselected: document.getElementById("complimentary-selected"),
            mobilecollapsablearrow: document.getElementById("mobile-collapsable-arrow"),
            secondvariantselecteditems: document.querySelector("#second-variants-selected-items .step-one-variant-selected"),
            highlightcountscontainer: document.getElementById("highlight-counts-container"),
            highlightscentrunningscount: document.getElementById("highlight-scents-running-count"),
            highlightscentsmaxcount: document.getElementById("highlight-scents-max-count")
        }
        this.state = {
            step_one: [],
            variantSizeLimit: 0,
            variantRunningCount: 0 
        }
        this.final = {
            onetimepurchase_el: document.getElementById("final-one-time-purchase"),
            first_product_price: 0,
            second_product_price: 0,
            first_product_discount_price: 0,
            second_product_discount_price: 0,
            total_discounted_price_el: document.getElementById("final-discounted-price"),
            total_regular_price_el: document.getElementById("final-cross-out-price"),
            current_currency: '$',
            first_variant_id: null,
            second_variants: [],
            first_variant_available: false
        }
        this.load();
    }
    MainTheStarterKit.prototype.load = function() {
        var _ = this;
        if(_.selector.productdetails.length > 0) {
            _.selector.productdetails.forEach(btn => {
                btn.addEventListener('click', event => {
                    const templateContent = event.target.closest('.image').querySelector(`#product-details-${event.target.closest('button').dataset.templateId}`).content;
                    _.selector.productdetailsmodal.querySelector(".render").innerHTML = "";
                    _.selector.productdetailsmodal.querySelector(".render").appendChild(document.importNode(templateContent, true));
                    _.selector.productdetailsmodal.classList.add('active');
                    _.selector.productdetailsmodaloverlay.classList.add('active');
                })
            })
        }
        if(_.selector.modalclose) {
            _.selector.modalclose.addEventListener('click', () => {
                _.selector.productdetailsmodal.classList.remove('active');
                _.selector.productdetailsmodaloverlay.classList.remove('active');
            })
        }
        if(_.selector.addtowizard.length > 0) {
            _.selector.addtowizard.forEach(btn => {
                btn.addEventListener('click', event => {
                    if(event.target.closest('button').dataset.stepsNumber === 'one') {            
                        _.selector.starterkitaddtocart.classList.add("active");
                        _.final.second_product_discount_price = _.final.second_product_discount_price + parseInt(event.target.closest('button').dataset.refinedPrice);
                        _.final.second_product_price = _.final.second_product_price + parseInt(event.target.closest('button').dataset.refinedPrice);
                        // to remove the decimals if the price doesn't have any
                        _.final.onetimepurchase_el.textContent = `${_.final.current_currency}${(_.final.second_product_price / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
                        if(!_.final.second_variants.includes(event.target.closest('button').dataset.variantId)) {
                            _.final.second_variants.push(event.target.closest('button').dataset.variantId);
                            _.state.variantRunningCount = _.state.variantRunningCount + 1;
                        }                        
                        const addednewscents = document.createElement("div");
                        addednewscents.classList.add("step-one-variant-selected");
                        addednewscents.classList.add("active");
                        addednewscents.dataset.variantId = event.target.closest('button').dataset.variantId;
                        addednewscents.dataset.variantTitle = event.target.closest('button').dataset.variantTitle;
                        addednewscents.innerHTML = `<button type="button" class="kit-close active" data-selected-title="Select an Oil">
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.59715 10.4031L10.4031 3.59716M3.59722 3.6531L10.3472 10.4031" stroke="black" stroke-width="1.16667" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>
                        <div class="image"><img src="${event.target.closest('button').dataset.variantImage}" alt="${event.target.closest('button').dataset.variantTitle}" width="125" height="125"></div>
                        <div class="selected-details active"><span class="title">${event.target.closest('button').dataset.variantTitle}</span><span class="pricing">
                        <span class="regular">${event.target.closest('button').dataset.regularPrice}</span>`;
                        _.selector.steponevariantselected.classList.remove("active");
                        _.selector.steponevariantselected.after(addednewscents);
                        // _.selector.secondvariantselecteditems.append(addednewscents);
                        _.state.step_one.push(event.target.closest('.item'));
                        _.recalculate();
                        document.querySelector('.step-one-variant-selected .kit-close.active').addEventListener('click', event => {
                            _.final.second_variants = event.target.closest(".step-one-variant-selected") ? _.final.second_variants.filter(variant => variant !== event.target.closest(".step-one-variant-selected").dataset.variantId) : [];
                            _.state.step_one = event.target.closest(".step-one-variant-selected") ? _.state.step_one.filter(item => item.dataset.variantId !== event.target.closest(".step-one-variant-selected").dataset.variantId) : [];
                            _.final.second_product_discount_price = _.final.second_product_discount_price - varPrice;
                            _.final.second_product_price = _.final.second_product_price - varPrice;
                            _.final.onetimepurchase_el.textContent = '';
                            event.target.closest(".step-one-variant-selected").remove();
                            document.querySelector('.step-one-variant-selected.initial').classList.add('active');
                            _.state.variantRunningCount = _.state.variantRunningCount - 1;
                            _.recalculate();      
                        })
                    }
                })
            })
        }
        if(_.selector.mobilecollapsablearrow) {
            _.selector.mobilecollapsablearrow.addEventListener("click", event => {
                event.target.closest(".steps-wizard").classList.toggle("active");
            })
        }
        if(_.selector.secondvariantselecteditems) {
            _.selector.secondvariantselecteditems.addEventListener("click", event => {
                _.final.second_variants = event.target.closest(".step-one-variant-selected") ? _.final.second_variants.filter(variant => variant !== event.target.closest(".step-one-variant-selected").dataset.variantId) : [];
                _.state.step_one = event.target.closest(".step-one-variant-selected") ? _.state.step_one.filter(item => item.dataset.variantId !== event.target.closest(".step-one-variant-selected").dataset.variantId) : [];

                _.recalculate();
            })
        }
        if(_.selector.starterkitaddtocart) {
            _.selector.starterkitaddtocart.addEventListener("click", () => {
                _.addtocart();
            })
        }
    }
    MainTheStarterKit.prototype.recalculate = function() {
        var _ = this;
        if(_.final.second_variants.length > 0) {
            const final_first_discounted_price = _.final.second_product_discount_price / 100;
            const final_total_discounted_price = final_first_discounted_price;
            const final_first_regular_price = (parseInt(_.final.first_product_price) + parseInt(_.final.second_product_price)) / 100;
            const final_total_regular_price = final_first_regular_price;
            _.final.total_discounted_price_el.textContent = `${_.final.current_currency}${final_total_discounted_price.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
            // to remove the decimals if the price doesn't have any
            if (_.final.total_discounted_price_el.textContent.slice(-2) == "00") {
                _.final.total_discounted_price_el.textContent = `${_.final.current_currency}${final_total_discounted_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
            }
            if(final_total_discounted_price != final_first_regular_price) {
                _.final.total_regular_price_el.textContent = `${_.final.current_currency}${final_total_regular_price.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;
            }
            _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
        }
        if(_.state.step_one.length > 0) {
            _.selector.addtowizard.forEach(wizard => {
                wizard.removeAttribute('disabled');
            })
            _.state.step_one.forEach(step => {
                step.querySelector(".add-to-wizard").setAttribute('disabled', 'disabled');
                step.classList.add("selected");
                step.classList.remove("disabled");
            })
        } else {
            _.selector.addtowizard.forEach(wizard => {
                wizard.removeAttribute('disabled');
            })
        }
        if(_.selector.addtowizard.length > 0) {
            _.selector.addtowizard.forEach(wizard => {
                wizard.closest(".item").classList.remove("selected", "disabled");
                wizard.closest(".item button").classList.remove("disabled");
            })
        }
        if(_.state.variantRunningCount >= window.minScents) {
            _.selector.starterkitaddtocart.disabled = false;
        } else {
            _.selector.starterkitaddtocart.disabled = true;
        }
        if(_.state.variantRunningCount == window.minScents && window.innerWidth < 1025) {
            document.querySelector('.steps-wizard').classList.add('active');
            let scrollingSection = document.querySelector('.main-samples');
            scrollingSection.scrollTo({
                top: scrollingSection.scrollHeight + 300,
                behavior: 'smooth'
            });
            window.scrollTo({top:500, behavior: 'smooth'});
        }
    }
    MainTheStarterKit.prototype.addtocart = async function() {
        var _ = this;
        var formData;
        itemArray = [];
        _.final.second_variants.forEach(item=> {
            itemArray.push(
                {
                    'id': item,
                    'quantity': 1
                }
            );
        })
        formData = {
            'items': itemArray,
        };
        _.selector.starterkitaddtocart.setAttribute('disabled', 'disabled');
        _.selector.starterkitaddtocart.querySelector('.text-line').classList.add('hide');
        _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.add('hide');
        _.selector.starterkitaddtocart.querySelector('.pricing').classList.add('hide');
        _.selector.starterkitaddtocart.querySelector('[data-loader]').classList.remove('hide');
        await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: {
            'Content-Type': 'application/json'
            },
            body: JSON.stringify(formData)
        })
        .then(response => {
            _.selector.starterkitaddtocart.removeAttribute('disabled');
            _.selector.starterkitaddtocart.querySelector('[data-loader]').classList.add('hide');
            _.selector.starterkitaddtocart.querySelector('.text-line').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.pricing').classList.remove('hide');
            return response.json();
        })
        .then(data => {
        })
        .catch((error) => {
            console.error('Error:', error);
            _.selector.starterkitaddtocart.removeAttribute('disabled');
            _.selector.starterkitaddtocart.querySelector('[data-loader]').classList.add('hide');
            _.selector.starterkitaddtocart.querySelector('.text-line').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.separator-dot').classList.remove('hide');
            _.selector.starterkitaddtocart.querySelector('.pricing').classList.remove('hide');
        });           
    }
    MainTheStarterKit = new MainTheStarterKit;
}
MainTheStarterKit();